import React from 'react'
import Grid from '@material-ui/core/Grid'
import Skeleton from '@material-ui/lab/Skeleton'
import Box from '@material-ui/core/Box'
import { OwnItemDetailsComponentProps } from './own-item-details-component.types'
import { useOwnItemDetailsComponentStyles } from './own-item-details-component.styles'
import { useListedItemDetailsComponentStyles } from '../../listed-item-details-page/listed-item-details-component/listed-item-details-component.styles'
import { ItemImageSlider } from '../../../shared/item-image-slider'
import { EmptyImageComponent } from './empty-image-component'
import { InfoComponent } from './info-component'
import { ItemState } from '../../../models'
import { useTranslation } from 'react-i18next'
import { Error } from '@material-ui/icons'
import { red } from '@material-ui/core/colors'

export const OwnItemDetailsComponent: React.FC<OwnItemDetailsComponentProps> = (
  props
) => {
  const {
    isCurrentUserOwner,
    images,
    itemCondition,
    currency,
    description,
    locale,
    currentPrice,
    name,
    nonprofit,
    nonprofitName,
    donorName,
    listedUtc,
    createdUtc,
    soldUtc,
    state,
    listedItemId,
    loading,
    city,
    editItemState,
    region,
    deliveryType,
    isLocalPickupAvailable,
    isShippingAvailable,
    setInStoreDeliveryType,
    onChangeMode,
    updateState,
  } = props

  const layoutClasses = useListedItemDetailsComponentStyles()
  const classes = useOwnItemDetailsComponentStyles()
  const { t } = useTranslation()

  const moderationBanner = () => (
    <div className={classes.moderationBanner}>
      <div className={classes.moderationBannerIcon}>
        <Error style={{ color: red[500] }} />
      </div>
      <div className={classes.moderationBannerText}>
        <div>{t('editItemDetailsPage.moderation.guidelineViolation')}</div>
        <strong>
          {t('editItemDetailsPage.moderation.rejectReasonText')}{' '}
          {t('editItemDetailsPage.moderation.inappropriateContent')}
        </strong>
      </div>
    </div>
  )

  const placeholderBlock = () => (
    <div>
      <Box pt={0.5}>
        <Skeleton className={layoutClasses.imgSkeleton} animation="wave" />
      </Box>
    </div>
  )

  const imgBlock = () =>
    images && images.length ? (
      <ItemImageSlider images={images} variant="ownerAuthenticated" />
    ) : (
      <EmptyImageComponent />
    )

  return (
    <div className={layoutClasses.wrapper}>
      {state === ItemState.Unlisted && moderationBanner()}
      <div className={layoutClasses.sliderBlock}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={7} className={layoutClasses.sliderSectionBig}>
            {loading ? placeholderBlock() : imgBlock()}
          </Grid>
          <Grid item xs={12} md={5}>
            <InfoComponent
              updateState={updateState}
              editItemState={editItemState}
              listedItemId={listedItemId}
              deliveryType={deliveryType}
              isCurrentUserOwner={isCurrentUserOwner}
              itemCondition={itemCondition}
              currency={currency}
              city={city}
              region={region}
              description={description}
              locale={locale}
              loading={loading}
              name={name}
              state={state}
              listedUtc={listedUtc}
              createdUtc={createdUtc}
              soldUtc={soldUtc}
              nonprofitName={nonprofitName}
              nonprofit={nonprofit}
              donorName={donorName}
              isLocalPickupAvailable={isLocalPickupAvailable}
              isShippingAvailable={isShippingAvailable}
              setInStoreDeliveryType={setInStoreDeliveryType}
              onChangeMode={onChangeMode}
              currentPrice={currentPrice}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
